import React from 'react';
import { useHistory } from 'react-router-dom';
import queryString from 'query-string';
import useFetch from 'hooks/useFetch';
import { toSnakeCase } from 'utils/response';
import {
  journalsCategoriesActionConfigs,
  journalsFreeActionConfigs,
  journalsNewActionConfigs,
  journalsRecommendedActionConfigs,
} from 'redux/actions/journals/journalsActions';
import {
  articlesNewActionConfigs,
  articlesTopActionConfigs,
} from 'redux/actions/articles/articlesActions';
import { newsNewActionConfigs } from 'redux/actions/news/newsActions';
import { BooksType } from 'components/Books/card/BooksCardTypes';
import {
  booksPopularActionConfigs,
  booksNewActionConfigs,
  booksRecommendedActionConfigs,
  booksParentsActionConfigs,
} from 'redux/actions/books/booksActions';
import { bannersConfigs } from 'redux/actions/banner/bannersActions';
import HomeView, { TabArticles } from './view/HomeView';

const HomePage = () => {
  const history = useHistory();
  const search = history.location.search || '';
  const queries = queryString.parse(search);
  const tabArticlesQuery = queries?.tabArticles as TabArticles || TabArticles.POPULAR;
  const tabBooksQuery = queries?.tabBooks as BooksType || BooksType.EBOOK;

  const slidersLimitParams = 15;
  const journalsParams = { offset: 0, limit: slidersLimitParams };
  const journalsNewParams = toSnakeCase({ withoutExcludedCat: true, offset: 0, limit: slidersLimitParams });
  const articlesParams = { offset: 0, limit: slidersLimitParams };
  const newsParams = { offset: 0, limit: 20 };
  const booksParams = { offset: 0, limit: slidersLimitParams };

  useFetch({
    actionConfigs: [
      bannersConfigs,
    ],
  });

  useFetch({
    actionConfigs: [
      newsNewActionConfigs(newsParams),
      journalsCategoriesActionConfigs,
      journalsRecommendedActionConfigs(journalsParams),
      journalsNewActionConfigs(journalsNewParams),
      journalsFreeActionConfigs(journalsParams),
    ],
  });

  const newsActionConfigs = tabArticlesQuery === TabArticles.NEW
    ? articlesNewActionConfigs(articlesParams)
    : articlesTopActionConfigs(articlesParams);

  useFetch({
    actionConfigs: [
      newsActionConfigs,
    ],
    dependencies: [tabArticlesQuery],
  });

  useFetch({
    actionConfigs: [
      booksPopularActionConfigs({ type: tabBooksQuery, ...booksParams }),
      booksRecommendedActionConfigs({ type: tabBooksQuery, ...booksParams }),
      booksParentsActionConfigs({ type: tabBooksQuery, ...booksParams }),
      booksNewActionConfigs({ type: tabBooksQuery, ...booksParams }),
    ],
    dependencies: [tabBooksQuery],
  });

  return (
    <HomeView />
  );
};

export default HomePage;
